import React from 'react'
import injectSheet from 'react-jss'
import styles from './pending-teacher.styles'
import { PobbleAvatar } from 'pobble-components/dist/pobble-avatar'
import { Cell } from 'pobble-components/dist/table'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import { errorHandler } from 'pobble-components/dist/error-handler'
import Button from 'pobble-components/dist/button'

const PendingTeacher = ({
  classes,
  id,
  schoolId,
  name,
  avatar,
  email,
  onApprove,
  onDecline
}) => {
  return (
    <tr>
      <Cell>
        <div className={classes.teacher}>
          <PobbleAvatar
            avatar={avatar}
            name={name}
            className={classes.avatar}
          />
          <span className={classes.name}>{name}</span>
        </div>
      </Cell>
      <Cell>{email}</Cell>
      <Cell>
        <span className={classes.pending}>Pending</span>
      </Cell>
      <Cell className={classes.actions}>
        <Button
          tall
          primary
          success
          action={() =>
            openConfirmationDialog({
              bodyText: `Are you sure you want to approve this teacher?`,
              confirmText: 'Yes',
              action: () =>
                onApprove({ id, name, avatar, email }).catch(errorHandler)
            })
          }>
          Approve
        </Button>
        <Button tall primary danger action={() => onDecline(id)}>
          Decline
        </Button>
      </Cell>
    </tr>
  )
}

export default injectSheet(styles)(PendingTeacher)
